import { createFeatureSelector } from '@ngrx/store';
import { billingAggregatorFeatureKey } from '../reducers';
import { BillingAggregatorState } from '../reducers/billing-aggregator.reducer';

export const selectBillingAggregator =
  createFeatureSelector<BillingAggregatorState>(billingAggregatorFeatureKey);
